export const INVALID_ADDRESS_MSG = "The address you entered is invalid or the selected state/county is not supported.";

export function showInvalidAddressToast(showToaster) {
  if (!showToaster || typeof showToaster !== 'function') return;
  try {
    showToaster({ message: INVALID_ADDRESS_MSG, visible: true, type: 'error' });
  } catch (e) {
    // swallow errors to avoid breaking callers
    // console.warn('showInvalidAddressToast failed', e);
  }
}
